import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { Loader2, MapPin } from 'lucide-react';
import { Input } from './ui/input';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Free OpenStreetMap address suggestions (proxied + cached by our backend).
export const AddressAutocomplete = ({ value, onChange, onSelect, state, ...inputProps }) => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const picked = useRef(false);

  useEffect(() => {
    if (picked.current) { picked.current = false; return undefined; }
    const q = (value || '').trim();
    if (q.length < 3) { setRows([]); return undefined; }
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const r = await axios.get(`${API}/geo/search`, { params: { q, state: state || undefined } });
        setRows(r.data.rows || []);
        setOpen(true);
      } catch { setRows([]); } finally { setLoading(false); }
    }, 700);
    return () => clearTimeout(t);
  }, [value, state]);

  const choose = (row) => {
    picked.current = true;
    setOpen(false);
    setRows([]);
    onSelect(row);
  };

  return (
    <div className="relative">
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => rows.length && setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        autoComplete="off"
        {...inputProps}
      />
      {loading && <Loader2 size={14} className="absolute right-3 top-3 animate-spin text-slate-400" data-testid="address-suggest-loading" />}
      {open && rows.length > 0 && (
        <ul className="absolute z-[1200] mt-1 w-full max-h-64 overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-xl" data-testid="address-suggest-list">
          {rows.map((r, i) => (
            <li key={`${r.lat}-${r.lng}-${i}`}>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => choose(r)}
                className="w-full text-left px-3 py-2 text-xs text-slate-700 hover:bg-emerald-50 flex gap-2 items-start"
                data-testid={`address-suggest-${i}`}
              >
                <MapPin size={12} className="mt-0.5 shrink-0 text-emerald-700" /> <span>{r.label}</span>
              </button>
            </li>
          ))}
          <li className="px-3 py-1 text-[9px] text-slate-400 border-t">© OpenStreetMap contributors</li>
        </ul>
      )}
    </div>
  );
};
